import { RootState } from "../types";

export const paymentSessionSelector = (state: RootState) => state.paymentSession;

export const selectedServiceIdSelector = (state: RootState) => state.paymentSession.selectedServiceId;

export const sessionPriceSelector = (state: RootState) => state.paymentSession.sessionPrice;

export const chargeAmountSelector = (state: RootState) => state.paymentSession.chargeAmount;

export const serviceNameSelector = (state: RootState) => state.paymentSession.serviceName;

export const serviceOptionsSelector = (state: RootState) => state.paymentSession.serviceOptions;

export const paymentTypeOptionsSelector = (state: RootState) => state.paymentSession.paymentTypeOptions;

export const selectedPaymentTypeIdSelector = (state: RootState) => state.paymentSession.selectedPaymentTypeId;

export const pendingPaymentSelector = (state: RootState) => state.paymentSession.pendingPayment;

export const questionnaireScoreStatusOptionsSelector = (state: RootState) =>
    state.paymentSession.questionnaireScoreStatusOptions;
